export const getters = {
  getBoundaries: state => {
    return state.boundaries
  },

  getCurrentBoundary: state => {
    return state.currentBoundary
  },

  getPlaceDetails: state => projectId => {
    if (!state.boundaries || !state.boundaries.features) return null
    const boundary = state.boundaries.features.find(
      f => f.properties.project_id === projectId
    )
    return boundary?.properties?.place_details || null
  },

  getHoveredBoundaryProjectId: state => state.hoveredBoundaryProjectId,
}
